import { render, staticRenderFns } from "./ServiceTypeForm.vue?vue&type=template&id=16daa642&scoped=true&"
import script from "./ServiceTypeForm.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypeForm.vue?vue&type=style&index=0&id=16daa642&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16daa642",
  null
  
)

export default component.exports